import Vue from 'vue'
import LottieAnimation from 'lottie-vuejs'

import axios from 'axios'
import * as query from '@/helpers/query.js'
import Errors from './helpers/errors.js'
import * as Utils from './helpers/utils.js'
import assets from './network/assets'
import * as api from './network/api'
import * as Network from '@/helpers/network.js'
import * as apiService from '@/helpers/apiService.js'
import * as assetUploader from '@/helpers/assetUploader.js'
import * as Notif from '@/helpers/notif.js'
import * as moment from 'moment'
import Notifications from 'vue-notification'
import t from '@/helpers/currencyTranslator'
import * as vodData from './views/VOD/vodData'

export default function setGlobalModules() {
    Vue.prototype.$query = query
    Vue.prototype.$Errors = Errors
    Vue.prototype.$Utils = Utils
    Vue.prototype.$assets = assets
    Vue.prototype.$api = api
    Vue.prototype.$t = t
    Vue.prototype.$axios = axios
    Vue.prototype.$Network = Network
    Vue.prototype.$Notif = Notif
    Vue.prototype.$moment = moment
    Vue.prototype.$apiService = apiService
    Vue.prototype.$assetUploader = assetUploader
    Vue.prototype.$vodData = vodData
    Vue.use(LottieAnimation)
    Vue.use(Notifications)
}
